import { useHistory } from "react-router-dom";
import Button from "../UI/Button";
import { getMidBanner } from '../../lib/api';
import { useSelector, useDispatch } from 'react-redux';
import { updateMidBanner } from '../../redux/midbannerSlice';
import { useCallback, useEffect } from "react";
import { MEDIA_ORIGIN } from "../../utils/Environment";

const MidBanner = () => {

    const history = useHistory();
    const { midbanner } = useSelector((state) => state.midbanner);
    const dispatch = useDispatch();
    const goToRegister = () => {
        history.push('/register')
    }

    const midbannersendRequest = useCallback(() => {
        getMidBanner()
            .then((response) => {
                if (response) {
                    dispatch(updateMidBanner(response[0]));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, [dispatch]);

    useEffect(() => {
        if (midbanner === null || midbanner.length === 0) {
            midbannersendRequest();
        }
    }, [midbannersendRequest, midbanner]);

    return (
        <section className="section midbannerSection">
            <div className={`h-[550px]  sm:h-[820px] max-w-[820px]:h-[820px] lg:h-[700px] flex justify-end items-center relative`}>
                {midbanner && midbanner.banner_asset ?
                <picture>
                    <source media="(min-width:821px)" srcSet={`${MEDIA_ORIGIN}${midbanner.banner_asset}`} className="size-full absolute object-contain xl:object-cover inset-0" />
                    <source media="(max-width:820px)" srcSet={`${MEDIA_ORIGIN}${midbanner.small_banner_asset}`} className="size-full absolute object-contain xl:object-cover inset-0" />
                    <img src={`${MEDIA_ORIGIN}${midbanner.banner_asset}`} alt="midBanner" className="size-full absolute   object-cover inset-0 object-top  lg:object-center" />
                </picture> : ""
                }
                {midbanner?.body ?<div className="midBannerContent relative max-w-full max-[820px]:max-w-full lg:max-w-[50%] xl:max-w-[40%] px-5 sm:px-5 md:px-5 lg:px-14 flex flex-col self-center max-[820px]:self-end">
                    <p className="text-white font-light sm:text-3xl sm:leading-[46px] text-xl leading-[30px]"><span dangerouslySetInnerHTML={{ __html: midbanner.body }}></span></p>
                    {midbanner.redirect_link ? <Button className="registerBtn h-[50px] btn max-w-fit font-medium text-lg sm:text-2xl leading-5 bg-primaryBlue text-white px-5 rounded mt-7 sm:mt-10 mb-7 lg:mb-0" type="button" onClick={goToRegister}>Register</Button>:""}
                </div>:""}
            </div>
        </section>
    )
}

export default MidBanner;
